/**
 * Button Template API Service
 * Client-side service for managing button templates
 */
import api from "./api";

export interface ButtonTemplate {
  id: number;
  key: string;
  label: string;
  trigger_phrases: string[];
  response_text: string;
  suggestion_buttons?: Array<{
    label: string;
    action: string;
    source?: string;
    type?: string;
    interaction_type?: string;
  }>;
  active: boolean;
  priority: number;
  created_at: string;
  updated_at: string;
}

export interface ButtonTemplateCreateInput {
  key: string;
  label: string;
  trigger_phrases: string[];
  response_text: string;
  suggestion_buttons?: Array<{
    label: string;
    action: string;
    source?: string;
    type?: string;
    interaction_type?: string;
  }>;
  active?: boolean;
  priority?: number;
}

export interface ButtonTemplateUpdateInput {
  label?: string;
  trigger_phrases?: string[];
  response_text?: string;
  suggestion_buttons?: Array<{
    label: string;
    action: string;
    source?: string;
    type?: string;
    interaction_type?: string;
  }>;
  active?: boolean;
  priority?: number;
}

/**
 * Get all button templates
 */
export const getAllButtonTemplates = () => {
  return api.get("/api/button-templates");
};

/**
 * Get active button templates
 */
export const getActiveButtonTemplates = () => {
  return api.get("/api/button-templates/active");
};

/**
 * Get button template by ID
 */
export const getButtonTemplateById = (id: number) => {
  return api.get(`/api/button-templates/${id}`);
};

/**
 * Create a new button template
 */
export const createButtonTemplate = (data: ButtonTemplateCreateInput) => {
  return api.post("/api/button-templates", data);
};

/**
 * Update button template
 */
export const updateButtonTemplate = (id: number, data: ButtonTemplateUpdateInput) => {
  return api.put(`/api/button-templates/${id}`, data);
};

/**
 * Delete button template
 */
export const deleteButtonTemplate = (id: number) => {
  return api.delete(`/api/button-templates/${id}`);
};

/**
 * Toggle button template status
 */
export const toggleButtonTemplateStatus = (id: number) => {
  return api.patch(`/api/button-templates/${id}/toggle`);
};
